import { CHANGE_HPRINTER_STATE } from "../actions/types";

const initialState = {
  hprinterState: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case CHANGE_HPRINTER_STATE:
      return {
        ...state,
        hprinterState: action.payload
      };
    default:
      return state;
  }
}
